export default __webpack_public_path__ + "static/media/_empty-chart-status-bg.f110803f.svg";